import styled from "styled-components";
import { Button } from "antd";

const WelcomeInternal = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 170px);
  padding: 1.5rem 0 5rem;
  background-color: #ebebeb;
`;

const InternalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: ${({ theme }) => theme.colors.level3};
`;

InternalHeader.Title = styled.h1`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.25rem;
  color: #f1f1f1;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.875rem;
  }
`;

InternalHeader.Description = styled.h6`
  font-weight: 600;
  font-size: 1.25rem;
  margin: 1.5rem 0 0.5rem;
  text-align: center;
  padding: 0 0 2rem;
  color: ${({ theme }) => theme.colors.dark};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.875rem;
  }
`;

InternalHeader.Icon = styled.img`
  height: 2rem;
  margin-right: 1rem;
`;

InternalHeader.ButtonBack = styled(Button)`
  color: #f1f1f1;

  .anticon {
    font-size: 1rem;
  }

  span {
    font-size: 0.75rem;
  }
`;

export default { WelcomeInternal, InternalHeader };
